import BigNumber from "bignumber.js";

export default function toPrice(num: any) {
  let amount = "0.00";
  if (num) {
    const bn = new BigNumber(num);
    amount = bn.toFormat(2, BigNumber.ROUND_HALF_UP);
  }

  if (amount[0] === "-") {
    return "-$" + amount.slice(1);
  } else {
    return "$" + amount;
  }
}
